import styled from 'styled-components';

export const Status = styled.div`
  color: var(--text);

  > svg {
    min-width: 18px;
    min-height: 18px;
    margin-right: 5px;
    color: currentColor;
  }
`;
